(function () {
  var init, bind, closeOnClick, WidgetTab;
  var nodes = {
    tabs: document.querySelectorAll("[data-widget-tab]"),
    close_button: document.querySelector("[data-widget-close]"),
  };

  WidgetTab = function (tab) {
    this.id = tab.getAttribute("data-widget-tab");
    this.tab = tab;
    this.isActive = tab.classList.contains("widget-tab--active");
    this.content = document.querySelector("[data-widget-content='" + this.id + "']");
    this.init();
  };

  WidgetTab.prototype.active = function (state) {
    this.isActive = state;
    var action = state ? "add" : "remove";
    this.tab.classList[action]("widget-tab--active");
    this.content.classList[action]("widget-content--active");
  };

  WidgetTab.prototype.hideOtherTabs = function () {
    this.fireEvent("widget-tab:hide", this);
  };

  WidgetTab.prototype.fireEvent = function (name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail }));
  };

  WidgetTab.prototype.handleMouseOver = function () {
    this.fireEvent("widget-tab:hovered", this);
    this.tab.removeEventListener("mouseover", this.handleMouseOverBound);
  };

  WidgetTab.prototype.handleClick = function () {
    this.hideOtherTabs();
    this.active(true);
  };

  WidgetTab.prototype.handleHideEvent = function () {
    if (!this.isActive) return;
    this.active(false);
  };

  WidgetTab.prototype.bind = function () {
    this.handleMouseOverBound = this.handleMouseOver.bind(this);
    this.tab.addEventListener("click", this.handleClick.bind(this));
    this.tab.addEventListener("mouseover", this.handleMouseOverBound);
    document.addEventListener("widget-tab:hide", this.handleHideEvent.bind(this));
  };

  WidgetTab.prototype.init = function () {
    this.bind();
  };

  closeOnClick = function () {
    var widgetId = this.getAttribute("data-widget-close");
    var widget = document.querySelector("[data-widget-id='" + widgetId + "']");
    if (!widget) return;
    widget.classList.add("widget--closed");
    sessionStorage.setItem("recently_widget_closed", true);
  };

  bind = function () {
    if (!nodes.close_button) return;
    nodes.close_button.addEventListener("click", closeOnClick);
  };
  init = function () {
    nodes.tabs.forEach(function (tab) {
      new WidgetTab(tab);
    });
    bind();
  };

  init();
})();
